var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluatedFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 12,
    fill: "url(#paint0_linear_1706_24534)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3332 35.6265L37.1332 36.1465C36.6398 36.2665 36.2532 36.6398 36.1465 37.1332L35.6798 39.0932C35.4265 40.1598 34.0665 40.4932 33.3598 39.6532L29.3732 35.0665C29.0532 34.6932 29.2265 34.1065 29.7065 33.9865C32.0665 33.4132 34.1865 32.0932 35.7465 30.2132C35.9998 29.9065 36.4532 29.8665 36.7332 30.1465L39.6932 33.1065C40.7065 34.1198 40.3465 35.3865 39.3332 35.6265Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6002 35.6265L16.8002 36.1465C17.2936 36.2665 17.6802 36.6398 17.7869 37.1332L18.2536 39.0932C18.5069 40.1598 19.8669 40.4932 20.5736 39.6532L24.5602 35.0665C24.8802 34.6932 24.7069 34.1065 24.2269 33.9865C21.8669 33.4132 19.7469 32.0932 18.1869 30.2132C17.9336 29.9065 17.4802 29.8665 17.2002 30.1465L14.2402 33.1065C13.2269 34.1198 13.5869 35.3865 14.6002 35.6265Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9998 13.667C21.8398 13.667 17.6665 17.8403 17.6665 23.0003C17.6665 24.9337 18.2398 26.707 19.2265 28.187C20.6665 30.3203 22.9465 31.827 25.5998 32.2137C26.0532 32.2937 26.5198 32.3337 26.9998 32.3337C27.4798 32.3337 27.9465 32.2937 28.3998 32.2137C31.0532 31.827 33.3332 30.3203 34.7732 28.187C35.7598 26.707 36.3332 24.9337 36.3332 23.0003C36.3332 17.8403 32.1598 13.667 26.9998 13.667ZM31.0798 22.707L29.9732 23.8137C29.7865 24.0003 29.6798 24.3603 29.7465 24.627L30.0665 26.0003C30.3198 27.0803 29.7465 27.507 28.7865 26.9337L27.4532 26.147C27.2132 26.0003 26.8132 26.0003 26.5732 26.147L25.2398 26.9337C24.2798 27.4937 23.7065 27.0803 23.9598 26.0003L24.2798 24.627C24.3332 24.3737 24.2398 24.0003 24.0532 23.8137L22.9198 22.707C22.2665 22.0537 22.4798 21.4003 23.3865 21.2537L24.8132 21.0137C25.0532 20.9737 25.3332 20.7603 25.4398 20.547L26.2265 18.9737C26.6532 18.1203 27.3465 18.1203 27.7732 18.9737L28.5598 20.547C28.6665 20.7603 28.9465 20.9737 29.1998 21.0137L30.6265 21.2537C31.5198 21.4003 31.7332 22.0537 31.0798 22.707Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1706_24534",
    x1: 27,
    y1: 0,
    x2: 27,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8A6",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#008578"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluatedFilled);
export default __webpack_public_path__ + "static/media/evaluatedFilled.c3cb729fc680602a99c705acf31874fa.svg";
export { ForwardRef as ReactComponent };